import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { Slide } from '@mui/material'
import toast, { Toaster } from 'react-hot-toast'
import { decodeToken } from 'react-jwt'
import { PBRUserDoc } from '@playback-rewards/shared-libraries'

//components
import BottomButton from 'components/common/BottomButton'
import AuthLayout from 'components/layout/Auth'
import PlatformSelectContent from './Content'
//constants
import { ANALYTICS_EVENT, LOCAL_STORAGE, PLATFORMS_ARRAY } from 'constants/index'
//contexts
import LoaderContext from 'context/LoaderContext'
import AuthContext from 'context/AuthContext'
//services
import { getUserByEmail, updateUserPlatform } from 'services/userService'
//styles
import './PlatformSelect.css'
//types
import { PlatformSelectForm } from 'types'
//utils
import { getRegistrationTitle, getUserPlatform, handleError, sendGA4Event } from 'utils/utils'
import useGeoDataQuery from '../../hooks/useGeoDataQuery'

const PlatformSelect = () => {
  const { login } = useContext(AuthContext)

  const { isLoading, showLoader, hideLoader } = useContext(LoaderContext)

  const [user, setUser] = useState<PBRUserDoc | undefined>()

  const navigate = useNavigate()

  const { geoData } = useGeoDataQuery()

  useEffect(() => showLoader(), [])

  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      country: '',
      signUpIPCountry: '',
      IPAddress: '',
      platform: '',
    },
  })

  const setData = async () => {
    const jwtToken = localStorage.getItem(LOCAL_STORAGE.JWT_TOKEN)

    if (jwtToken) {
      const decodedToken = decodeToken<any>(jwtToken)

      const existedUser = await getUserByEmail(decodedToken.email).catch(handleError)

      if (existedUser) {
        setUser(existedUser)
        if (!sessionStorage.getItem('firstName')) {
          sessionStorage.setItem('firstName', existedUser.firstName)
        }
        setValue('country', existedUser.country)
        setValue(
          'platform',
          existedUser.platform !== 'Web' ? existedUser.platform : PLATFORMS_ARRAY[0]
        )
      } else {
        setValue('platform', getUserPlatform())

        const country = geoData?.country_code2 || ''
        const ip = geoData?.ip || ''
        setValue('signUpIPCountry', country)
        setValue('IPAddress', ip)
        setValue('country', country)
      }
    } else {
      toast.error('Something went wrong. Please try again!')
    }
  }

  useEffect(() => {
    showLoader()
    setData().finally(hideLoader)
  }, [])

  const onSubmit = async (values: PlatformSelectForm) => {
    showLoader()

    const jwtToken = localStorage.getItem(LOCAL_STORAGE.JWT_TOKEN)

    if (jwtToken) {
      await login(jwtToken, true)

      const decodedToken = decodeToken<any>(jwtToken)

      await updateUserPlatform({ userId: decodedToken.id, platform: values.platform }).catch(
        handleError
      )

      sendGA4Event(ANALYTICS_EVENT.TUTORIAL_BEGIN, {}, jwtToken)
    } else {
      toast.error('Something went wrong. Please try again!')
    }
    hideLoader()
  }

  return (
    <>
      <Toaster />
      <Slide direction="left" in={true} mountOnEnter unmountOnExit>
        <div className={isLoading ? 'blured' : ''}>
          <AuthLayout
            title={getRegistrationTitle(user)}
            content={
              <PlatformSelectContent
                handleSubmit={handleSubmit}
                onSubmit={onSubmit}
                control={control}
              />
            }
          >
            <BottomButton handleClick={handleSubmit(onSubmit)} style={{ marginBottom: '20px' }}>
              Continue
            </BottomButton>
          </AuthLayout>
        </div>
      </Slide>
    </>
  )
}

export default PlatformSelect
